import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "../context/CartContext";

// Componentes de Navegación
import Nav from "./Nav";
import NavMenu from "./NavMenu";
import Cart from "./Cart";

// Vistas
import Home from "./Home";
import Tienda from "./Tienda.jsx";
import ItemListContainer from "../components/ItemListContainer";
import ItemDetailContent from "./ItemDetailContent";
import Talleres from "./Talleres";
import TallerDetailContent from "./talleres/TallerDetailContent";
import Actividades from "./Actividades";
import Show from "./Show";

const Main = () => {
  const location = useLocation();
  const [showCart, setShowCart] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const handleCartModal = () => setShowCart(!showCart);

  // 1. LAYOUT PARA EL PANEL DE ADMINISTRACIÓN
  // Usamos includes para que cualquier ruta que contenga /admin (como /admin/login)
  // cargue el panel limpio sin Nav ni Footer.
  if (location.pathname.includes("/admin")) {
    return (
      <CartProvider>
        <div className="container-fluid sinBorde">
          <Routes>
            <Route
              path="/admin"
              element={<Show isAdmin={isAdmin} setIsAdmin={setIsAdmin} />}
            />
          </Routes>
        </div>
      </CartProvider>
    );
  }

  // 2. LAYOUT PÚBLICO (Tienda, Inicio, Detalle)
  return (
    <CartProvider>
      {/* Componentes fijos de la tienda */}
      <Nav handleCartModal={handleCartModal} />
      <NavMenu />
      <Cart show={showCart} handleModal={handleCartModal} />

      <div className="container-fluid sinBorde">
        <Routes>
          {/* Inicio */}
          <Route path="/" element={<Home />} />

          {/* Tienda y Categorías */}
          <Route path="/tienda" element={<Tienda />} />
          <Route
            path="/tienda/:nombreCategoria"
            element={<ItemListContainer />}
          />

          {/* DETALLES: Primero la ruta con slug por si el usuario entra desde afuera, 
              luego la ruta solo con ID. Ambas cargan el mismo componente. */}
          <Route
            path="/detalle/:idProducto/:slug"
            element={<ItemDetailContent handleCartModal={handleCartModal} />}
          />
          <Route
            path="/detalle/:idProducto"
            element={<ItemDetailContent handleCartModal={handleCartModal} />}
          />

          {/* Talleres y Actividades */}
          <Route path="/talleres" element={<Talleres />} />
          <Route
            path="/talleres/:idProducto"
            element={<TallerDetailContent />}
          />
          <Route
            path="/talleres/:idProducto/:slug"
            element={<TallerDetailContent />}
          />
          <Route path="/actividades" element={<Actividades />} />

          {/* Fallbacks por si el usuario escribe en mayúsculas */}
          <Route path="/Tienda" element={<Tienda />} />
          <Route path="/Talleres" element={<Talleres />} />
        </Routes>
      </div>
    </CartProvider>
  );
};

export default Main;
